export function getInitials(name: string | null | undefined, fallback = "?"): string {
    if (!name || !name.trim()) {
        return fallback;
    }

    const parts = name.trim().split(/\s+/);
    const alphanumeric = /\p{L}/u;

    if (parts.length === 1) {
        const char = parts[0]?.[0] ?? "";
        return alphanumeric.test(char) ? char.toUpperCase() : fallback;
    }

    const firstLetter = parts[0]?.[0] ?? "";
    const secondLetter = parts[parts.length - 1]?.[0] ?? "";
    const initials = [firstLetter, secondLetter].filter((c) => alphanumeric.test(c)).join("").toUpperCase();
    return initials || fallback;
}
